<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">Address</strong>
      </div>
      <AddressDialog :account="account" />
    </template>

    <Item icon="mdi-map-marker" class="mt-n2">
        <strong>
          {{ account.address.street }}, {{ account.address.city }}, 
          {{ account.address.state }}, {{ account.address.zipcode }}
        </strong>
    </Item>
    <!-- <l-map  style="height: 175px" :zoom="zoom" :center="center">
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker :lat-lng="center" />
    </l-map> -->
    <div v-if="!account.address.place_id"
      class="grey lighten-2 text-center d-flex flex-column justify-center text--bold" 
      style="height: 175px; font-size: 20px;"
    >
      Please confirm your address<br><br>
      <span style="font-size: 14px;">Edit your address above and choose an<br>address from the autocomplete list.</span>
    </div>

  </Section>
</template>

<script>
  import { Section, Item } from '@/components/pages'
  import AddressDialog from '../dialogs/Address.vue'
  import { latLng } from "leaflet"
  // import { LMarker, LMap, LTileLayer } from 'vue2-leaflet'

  export default {
    name: 'AccountAddressSection',

    components: { AddressDialog, Section, Item },

    props: ['account'],

    data() {
      return {
        zoom: 8,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      }
    },

    computed: {
      center() {
        return latLng(this.account.address.latitude, this.account.address.longitude)
      },

      radius() { 
        // in meters
        return this.account.coverage_radius * 1609.34
      },
    },
  }
</script>